const GoldenStar = (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#FFF8EF" />
    <path
      d="M24.25 14.5498L27.34 20.8098L34.25 21.8198L29.25 26.6898L30.43 33.5698L24.25 30.3198L18.07 33.5698L19.25 26.6898L14.25 21.8198L21.16 20.8098L24.25 14.5498Z"
      stroke="#FFBC00"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default GoldenStar;
